import { render } from "./PointSettingsView.vue?vue&type=template&id=073e3be0&scoped=true"
import script from "./PointSettingsView.vue?vue&type=script&lang=js"
export * from "./PointSettingsView.vue?vue&type=script&lang=js"

import "./PointSettingsView.vue?vue&type=style&index=0&id=073e3be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073e3be0"]])

export default __exports__